let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("8ouLA"), load("1jwHU"), load("hB7AO")]).then(() => parcelRequire('eYxlk'));